import RRLogoUrl from '@assets/rr-logo.svg';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Space, Typography } from 'antd';
import { useUserInfo } from 'src/lib/customHooks';
import { IconUser } from '../BasicComponents/Icons';

const { Text } = Typography;

function RacemapUserIdOrName({ userId }: { userId: string }) {
  const { user, isUnknownUser } = useUserInfo(userId);
  return (
    <Space title={`User Id of the Racemap user who uploaded this read: ${userId}`}>
      <IconUser style={{ color: RacemapColors.PaleBlue }} />
      <Text ellipsis>» {isUnknownUser ? userId : user?.name}</Text>
    </Space>
  );
}

export function UserOrCustomerId({
  userOrCustomerId,
}: { userOrCustomerId?: string }): React.ReactElement {
  return (
    <div style={{ display: 'flex', alignItems: 'left', width: '100%', marginLeft: '5px' }}>
      {userOrCustomerId != null && userOrCustomerId !== '' && userOrCustomerId.length === 36 ? (
        <RacemapUserIdOrName userId={userOrCustomerId} />
      ) : userOrCustomerId != null ? (
        <div
          title={`Customer Id of the Race Result customer who uploaded this read: ${userOrCustomerId}`}
        >
          <IconUser style={{ color: RacemapColors.PaleBlue, position: 'relative', top: '1px' }} />
          &nbsp;{' '}
          <a href="https://www.raceresult.com/de-de/support/kb.php%3Fid=13008-RaceMap-Access">
            <img
              width="20px"
              src={RRLogoUrl}
              alt="RR"
              style={{ position: 'relative', top: '-1px' }}
            />
          </a>{' '}
          {userOrCustomerId}
        </div>
      ) : (
        <div>-</div>
      )}
    </div>
  );
}
